// src/com/auto_dida_info/AutoDidaInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * AUTO_DIDA_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-18 15:21:54 using DbdbTap.
 ************************************************ */

const AUTO_DIDA_INFO_LIST_PART = gql`
fragment AutoDidaInfoListPart on AutoDidaInfo {
    dcCd
    storeId
    didaDate
    weekDay
    regDate
    regUser
    dcName
    storeName
    regUserName
}
`;



export const LIST_AUTO_DIDA_INFO = gql`
${AUTO_DIDA_INFO_LIST_PART}
query ListAutoDidaInfo($dcCd:String!, $dateFrom:String!) {
    autoDidaInfoList(dcCd:$dcCd, dateFrom:$dateFrom) {
        ...AutoDidaInfoListPart
    }
}
`;

// autoDidaInfoCounts(dateFrom:String!): [AutoDidaInfo]!
export const LIST_AUTO_DIDA_INFO_COUNTS = gql`
query ListAutoDidaInfoCounts($dateFrom:String!) {
    autoDidaInfoCounts(dateFrom:$dateFrom) {
        dcCd
        dcName
        weekDay
        didaCount
    }
}
`;

export const GET_AUTO_DIDA_INFO = gql`
${AUTO_DIDA_INFO_LIST_PART}
query GetAutoDidaInfo($dcCd:String!, $storeId:String!, $didaDate:String!) {
    autoDidaInfoItem(dcCd:$dcCd, storeId:$storeId, didaDate:$didaDate) {
        ...AutoDidaInfoListPart
    }
}
`;

export const ADD_AUTO_DIDA_INFO = gql`
mutation AddAutoDidaInfo($autoDidaInfo:InputAutoDidaInfoAdd!) {
	autoDidaInfoAdd(autoDidaInfo: $autoDidaInfo) {
		ok
		message
	}
}
`;

export const EDIT_AUTO_DIDA_INFO = gql`
mutation EditAutoDidaInfo($autoDidaInfo:InputAutoDidaInfoEdit!) {
	autoDidaInfoEdit(autoDidaInfo: $autoDidaInfo) {
		ok
		message
	}
}
`;

export const REMOVE_AUTO_DIDA_INFO = gql`
mutation RemoveAutoDidaInfo($autoDidaInfo:InputAutoDidaInfoRemove!) {
	autoDidaInfoRemove(autoDidaInfo: $autoDidaInfo) {
		ok
		message
	}
}
`;
/*
autoDidaInfoUpload(autoDidaInfoList: [InputAutoDidaInfoAdd]!): ResponseWithAutoDidaInfoResList

type AutoDidaInfoResponse {
	ok: Boolean!
	message: String
    dcCd: String!
    storeId: String!
    didaDate: String!
}

type ResponseWithAutoDidaInfoResList {
    ok: Boolean!
    message: String
    list: [AutoDidaInfoResponse]!
}

*/
export const UPLOAD_AUTO_DIDA_INFO = gql`
mutation UploadAutoDidaInfo($autoDidaInfoList: [InputAutoDidaInfoAdd]!) {
    autoDidaInfoUpload(autoDidaInfoList: $autoDidaInfoList) {
        ok
        message
        list {
            ok
            message
            dcCd
            storeId
            didaDate
        }
    }
}
`;
